export default "__VITE_ASSET__ChpxwS72__"